var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChevronRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.1924 7.02755C9.00615 7.21491 8.90161 7.46836 8.90161 7.73255C8.90161 7.99674 9.00615 8.25019 9.1924 8.43755L12.7324 12.0275L9.1924 15.5675C9.00615 15.7549 8.90161 16.0084 8.90161 16.2725C8.90161 16.5367 9.00615 16.7902 9.1924 16.9775C9.28537 17.0713 9.39597 17.1457 9.51783 17.1964C9.63969 17.2472 9.77039 17.2733 9.9024 17.2733C10.0344 17.2733 10.1651 17.2472 10.287 17.1964C10.4088 17.1457 10.5194 17.0713 10.6124 16.9775L14.8524 12.7375C14.9461 12.6446 15.0205 12.534 15.0713 12.4121C15.1221 12.2903 15.1482 12.1596 15.1482 12.0275C15.1482 11.8955 15.1221 11.7648 15.0713 11.643C15.0205 11.5211 14.9461 11.4105 14.8524 11.3175L10.6124 7.02755C10.5194 6.93382 10.4088 6.85943 10.287 6.80866C10.1651 6.75789 10.0344 6.73175 9.9024 6.73175C9.77039 6.73175 9.63969 6.75789 9.51783 6.80866C9.39597 6.85943 9.28537 6.93382 9.1924 7.02755Z",
    fill: "#080808"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronRight);
export default __webpack_public_path__ + "static/media/chevron_right.f3fede9d78ccff2c4cc08ac76fcdbacb.svg";
export { ForwardRef as ReactComponent };